// ----------------------------------------------------------------------

export default function Menu(theme) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: theme.shape.borderRadiusMd,
          boxShadow: theme.customShadows.z24,
          border: `1px solid ${theme.palette.divider}`,
          backgroundImage: 'none',
          marginTop: theme.spacing(0.5),
        },
      },
      defaultProps: {
        disableScrollLock: true,
      },
    },
  };
}
